import React from 'react';

import { useState, useRef, useEffect, useContext } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Col, Row, Modal } from 'react-bootstrap';

import AppContext from '../../AppContext';
import Alert from '../Alert';
import Tooltip from '../Tooltip';

import { email, salutation, firstName, lastName, phoneNo } from '../Schema';
import ModalCloseButton from '../Modal/ModalCloseButton';

import MandatoryFieldNotice from '../MandatoryFieldNotice';

const schema = yup.object().shape({
    salutation: salutation,
    firstname: firstName,
    lastname: lastName,
    email: email,
    phone: phoneNo,
});

const EditContactperson = ({ modal, setModal, person, setPerson, editPerson, contactLabel, message, userType }) => {
    const { Salutations } = useContext(AppContext);
    const formRef = useRef();
    const [criminalRecordFile, setCriminalRecordFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    const [criminalRecordStatus, setCriminalRecordStatus] = useState(person.CriminalRecord);

    const closeModal = () => {
        setPerson(false);
        setModal(false);
    }

    const handleCriminalRecordFileupload = function (e) {
        var fileNode = document.createElement("input");
        fileNode.type = "file";
        fileNode.addEventListener("change", function (e2) {
            setCriminalRecordFile(e2.currentTarget.files[0]);
        });
        fileNode.click();
    }

    useEffect(() => {
        if (!person || !formRef.current) return;
        
        formRef.current.setFieldValue("salutation", person.SalutationID || 1);
        formRef.current.setFieldValue("title", person.Title || "");
        formRef.current.setFieldValue("firstname", person.FirstName || "");
        formRef.current.setFieldValue("lastname", person.LastName || "");
        formRef.current.setFieldValue("phone", person.PhoneNo || "");
        formRef.current.setFieldValue("email", person.Email || "");
        formRef.current.setFieldValue("default", person.DefaultPerson);
        formRef.current.setFieldValue("reminderOptIn", person.ReminderOptIn);
        formRef.current.setFieldValue("criminalRecord", person.CriminalRecord == 0 || person.CriminalRecord == 1 ? false : true);
    }, [person]);

    return (
        <Modal centered show={modal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>{contactLabel} bearbeiten</Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                {message && <Alert type="error" message={message} />}

                <Formik
                    innerRef={(f) => (formRef.current = f)}
                    validationSchema={schema}
                    onSubmit={(values) => {
                        values.criminalRecordFile = criminalRecordFile;
                        editPerson(values);
                    }}
                    initialValues={{
                        salutation: '1',
                        title: '',
                        firstname: '',
                        lastname: '',
                        email: '',
                        phone: '',
                        default: false,
                        reminderOptIn: true,
                        criminalRecord: false,
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3" controlId="salutation">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label className="required" sm={6}>Anrede</Form.Label>
                                        <Tooltip name="anrede" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Select className="form-control" enabled="true" isInvalid={errors.salutation && touched.salutation} name="salutation" value={values.salutation} onBlur={handleBlur} onChange={handleChange}>
                                            {Salutations.map((option) => {
                                                return (
                                                    <option key={option.SalutationID} value={option.SalutationID}>
                                                        {option.Description}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.salutation}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="title">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label sm={6}>Titel</Form.Label>
                                        <Tooltip name="titel" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.title && touched.title} type="text" name="title" value={values.title} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.title}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="firstname">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label className="required" sm={6}>Vorname</Form.Label>
                                        <Tooltip name="vorname" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.firstname && touched.firstname} type="text" name="firstname" value={values.firstname} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.firstname}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="lastname">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label className="required" sm={6}>Nachname</Form.Label>
                                        <Tooltip name="nachname" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.lastname && touched.lastname} type="text" name="lastname" value={values.lastname} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.lastname}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="email">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label className="required" sm={6}>E-Mail-Adresse</Form.Label>
                                        <Tooltip name="email" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.email && touched.email} type="text" name="email" value={values.email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="phone">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label sm={6}>Telefon</Form.Label>
                                        <Tooltip name="telefon" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.phone && touched.phone} type="text" name="phone" value={values.phone} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.phone}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="default">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label sm={6}>Standard-{contactLabel}</Form.Label>
                                        <Tooltip name="kontaktperson-standard" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Check className="d-flex align-items-center justify-content-center h-100" aria-label={"Ist " + contactLabel +" Standard?"} name="default" checked={values.default} disabled={person.DefaultPerson} value="1" onBlur={handleBlur} onChange={handleChange} />
                                    </Col>
                                    {values.default && !person.DefaultPerson && (
                                        <Col className="text-warning" sm={12}>
                                            Diese Person wird zur neuen Standard-{contactLabel}.
                                        </Col>
                                    )}
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="reminderOptIn">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label sm={6}>Möchte an anstehende Termine erinnert werden</Form.Label>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Check className="d-flex align-items-center justify-content-center h-100" aria-label={"Möchte an anstehende Termine erinnert werden"} name="reminderOptIn" checked={values.reminderOptIn} value="1" onBlur={handleBlur} onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                {userType != "School" && (
                                    <Form.Group as={Row} className="mb-3" controlId="criminalRecord">
                                        {/*{userType == "Operator" && (*/}
                                        {/*    <>*/}
                                        {/*        <Col sm={6}>*/}
                                        {/*            <Form.Label sm={6}>Erweitertes Führungszeugnis verifiziert?</Form.Label>*/}
                                        {/*        </Col>*/}
                                        {/*        <Col sm={6}>*/}
                                        {/*            <Form.Check className="d-flex align-items-center justify-content-center h-100" aria-label={"Erweitertes Führungszeugnis verifiziert?"} name="criminalRecord" checked={values.criminalRecord} value="0" onBlur={handleBlur} onChange={handleChange} />*/}
                                        {/*        </Col>*/}
                                        {/*    </>*/}
                                        {/*)}*/}
                                        {/*{userType == "Business" && (*/}
                                        {/*    <>*/}
                                        {/*        {!person.CriminalRecord && (*/}
                                        {/*            <Col xs={12}>*/}
                                        {/*                {!criminalRecordFile && (*/}
                                        {/*                    <Button variant="primary" id="businessLicenseBtn" type="button" className="me-2 btn-block" onClick={handleCriminalRecordFileupload}>*/}
                                        {/*                        <i className="fa-solid fa-upload me-2"></i>Erweitertes Führungszeugnis hochladen*/}
                                        {/*                    </Button>*/}
                                        {/*                )}*/}
                                        {/*                {criminalRecordFile && (*/}
                                        {/*                    <Button variant="primary" type="button" className="me-2 btn-block" onClick={handleCriminalRecordFileupload}>*/}
                                        {/*                        <i className="fa-solid fa-upload me-2"></i> {criminalRecordFile.name}*/}
                                        {/*                    </Button>*/}
                                        {/*                )}*/}
                                        {/*                <div className="text-danger">{errorMessage}</div>*/}
                                        {/*            </Col>*/}
                                        {/*        )}*/}
                                        {/*        {person.CriminalRecord == 1 && (*/}
                                        {/*            <Col xs={12}>*/}
                                        {/*                <Button variant="primary" id="businessLicenseBtn" type="button" className="me-2 btn-block" onClick={handleCriminalRecordFileupload} disabled>*/}
                                        {/*                    Erweitertes Führungszeugnis in Prüfung*/}
                                        {/*                </Button>*/}
                                        {/*                <div className="text-danger">{errorMessage}</div>*/}
                                        {/*            </Col>*/}
                                        {/*        )}*/}
                                        {/*        {person.CriminalRecord == 2 && (*/}
                                        {/*            <Col xs={12}>*/}
                                        {/*                <Button variant="primary" id="businessLicenseBtn" type="button" className="me-2 btn-block" onClick={handleCriminalRecordFileupload} disabled>*/}
                                        {/*                    Erweitertes Führungszeugnis verifiziert*/}
                                        {/*                </Button>*/}
                                        {/*                <div className="text-danger">{errorMessage}</div>*/}
                                        {/*            </Col>*/}
                                        {/*        )}*/}
                                        {/*    </>*/}
                                        {/*)}*/}
                                    </Form.Group>
                                )}

                                <MandatoryFieldNotice />
                            </Form>
                        )
                    }}
                </Formik>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="secondary" onClick={() => formRef.current.submitForm()}>
                    Speichern
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default EditContactperson;